import React from "react";
import { theme } from "../../styles";

export interface SVGProps {
  SVGElement: React.FC | string;
  fill?: string;
  className?: string;
  width?: number;
  height?: number;
}

// Without this, some svg wont get the fill color
const svgParent = `[&>svg]:fill-inherit`;

export const SVG = ({
  SVGElement,
  fill = `${theme["--ll-color-on-background"]}`,
  className,
  height = 24,
  width = 24,
}: SVGProps) => (
  <div
    className={`${className} ${svgParent}`}
    style={{ height: `${height}px`, width: `${width}px`, fill }}
  >
    <SVGElement />
  </div>
);
